import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faEye,
  faEyeSlash,
  faUserSecret,
  faRandom,
  faSignOutAlt,
  faUserCog,
  faUsers,
  faCogs,
  faMoon,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faEye,
  faEyeSlash,
  faUserSecret,
  faRandom,
  faSignOutAlt,
  faUserCog,
  faUsers,
  faCogs,
  faMoon,
);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
